import React, { Component } from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';
import { Grid, Typography, Button, CircularProgress } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import environment from '../../environment';

class Roster extends Component {
    constructor(props){
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e){
        const value = e.currentTarget.value;
        const currentTier = this.props.currentTier;
        let playerData = {};
        value.split("/").map(str => {
            let key = str.split(":")[0].trim();
            let value = str.split(":")[1].trim();
            playerData[key] = value;
        })
        this.props.setTier(currentTier, playerData)
    }

    render(){
        const { classes, tier, numTier, currentTier, changeTier, params } = this.props;
        const numToEng = ["ONE", "TWO", "THREE"]
        const selected = tier ? tier[currentTier] : null;
        return (
            <>
            <Grid item xs={12}>
                { currentTier != 0 ? <ArrowBackIcon className={classes.leftArrow} onClick={() => changeTier(currentTier - 1)} /> : <></> }
                { currentTier != 2 ? <ArrowForwardIcon className={classes.rightArrow} onClick={() => changeTier(currentTier + 1)} /> : <></>}
                <Typography className={classes.tierTitle}>TIER {numToEng[currentTier]}</Typography>
            </Grid>
            <QueryRenderer
                environment={environment}
                variables={{
                    draftArguments: {game_id: params.game_id, quarter_id: 1, group_id: currentTier+1}
                }}
                query={graphql`
                    query RosterQuery(
                        $draftArguments: draftArgumentsInputType
                    ){
                        getDraftingOptions(draftArguments: $draftArguments){
                            code
                            message
                            data {
                                _id
                                game_id
                                quarter_id
                                group_id
                                external_player_id
                                option {
                                    _id
                                    option
                                    option_type_id
                                }
                            }
                        }
                    }`
                }
                render={({ error, props }) => {
                    if (error) {
                    return <div>No Records Found.</div>;
                    } else if (props) {
                        const players = props.getDraftingOptions.data;
                        return (
                            players.map((data) => {
                                const name = data.option.option
                                const i = data.option._id
                                let active = false;
                                if (selected){
                                    selected.forEach(player => {
                                        if (player && player.option_name == name) active = true;
                                    })
                                }
                                let optionStr = obj => `/option_id:${obj.option._id}/option_name:${obj.option.option}/option_type:${obj.option.option_type_id}`;
                                let toString = obj => Object.entries(obj).slice(0,-1).map(([k, v]) => `${k}: ${v}`).join('/') + optionStr(obj);
                                return (
                                    <Grid item xs={3} key={i}>
                                    {active?
                                        <Button
                                        variant="outlined"
                                        className={classes.selectedButton}
                                        value={toString(data)}
                                        onClick={(e) => this.handleClick(e)}
                                        >
                                            {name}
                                        </Button>
                                    :
                                        <Button
                                        variant="outlined"
                                        className={classes.nameButton}
                                        value={toString(data)}
                                        onClick={(e) => this.handleClick(e)}
                                        >
                                            {name}
                                        </Button>
                                    }
                                </Grid>
                                )
                            })   
                        )
                    } else {
                        return <CircularProgress />;
                    }
                }}
            />
            <Grid item xs={12}>
                    <Typography className={classes.pageArrow}>
                        { currentTier != 2 ? <ArrowForwardIcon onClick={() => changeTier(currentTier + 1)} /> : <ArrowBackIcon className={classes.disabled} />}
                    </Typography>
                    <Typography className={classes.pageNum}>
                        {currentTier+1} / {numTier}
                    </Typography>
                    <Typography className={classes.pageArrow}>
                        { currentTier != 0 ? <ArrowBackIcon onClick={() => changeTier(currentTier - 1)} /> : <ArrowBackIcon className={classes.disabled} /> }
                    </Typography>
            </Grid>
            </>
        )
    }
}

export default withStyles(useStyles)(Roster);